/**
 * Placeholder for the editor.
 */
export function Placeholder() {
  return (
    <div className="pointer-events-none absolute left-3 top-[9px] inline-block select-none overflow-hidden text-ellipsis text-muted-foreground">
      Enter some plain text...
    </div>
  );
}
